// extracted by mini-css-extract-plugin
export default {"banner_box":"index_banner_box_TGcjz","banner":"index_banner_dHBQD","brandImgUrl":"index_brandImgUrl_wLbsI","brandImgLink":"index_brandImgLink_IDCm1"};